'use strict';
module.exports = [
    'async',
    'autofocus',
    'autoplay',
    'checked',
    'controls',
    'default',
    'defaultchecked',
    'defer',
    'disabled',
    'formnovalidate',
    'hidden',
    'ismap',
    'loop',
    'multiple',
    'muted',
    'novalidate',
    'open',
    'playsinline',
    'readonly',
    'required',
    'reversed',
    'selected'
];